module.exports = __webpack_public_path__ + "static/media/fog-icon.0ef28f0b.svg";